/* eslint-disable jsx-a11y/img-redundant-alt */

import { useState } from "react";
import lineLogin from "Assets/other/login-line.svg";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import Spinner from "Component/Spinner";
import { EncryptStorage } from "encrypt-storage";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleError = (error) => {
    Notify.error({
      title: "Gagal",
      description: error?.response?.data?.message,
    });
  };

  const loginService = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi("auth").post(`/auth/login`, {
        email: email,
        password: password,
      });
      setIsLoading(false);
      localStorage.setItem("isLogin", true);
      encryptStorage.setItem("___info", response.data?.data);
      window.location.reload();
    } catch (err) {
      setIsLoading(false);
      handleError(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // localStorage.setItem("isLogin", true);
    // encryptStorage.setItem("___info", response.data?.data);
    // window.location.reload();
    loginService();
  };

  return (
    <div
      className="min-h-screen bg-no-repeat bg-cover flex items-center justify-center"
      style={{ backgroundColor: "#EEEDEB" }}
    >
      <div className="flex items-center justify-center w-full px-4 lg:px-0">
        <div className="flex flex-col items-center justify-center p-4 lg:py-6 lg:px-8 rounded-3xl sm:w-1/4 bg-white w-full min-w-[400px] border-solid border-gray-300 border shadow-xl">
          <div className="sm:mx-auto sm:w-full ">
            <img
              className="mx-auto h-40 w-auto"
              src={process.env.REACT_APP_LOGO_LOGIN}
              alt={process.env.REACT_APP_APPS_NAME}
            />
            <img
              className="mx-auto w-auto pt-4"
              src={lineLogin}
              alt="Line Picture"
            />
          </div>

          <div className="mt-4 mx-auto w-full ">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium leading-6"
                >
                  Email
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={email}
                    placeholder="Please input your email..."
                    onChange={(e) => setemail(e.target.value)}
                    required
                    className="h-11 block px-2 w-full rounded-xl border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div>
                <div className="flex items-center justify-between">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium leading-6"
                  >
                    Password
                  </label>
                </div>
                <div className="mt-2 relative">
                  <input
                    id="password"
                    name="password"
                    placeholder="Please input your password..."
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setpassword(e.target.value)}
                    required
                    className="h-11 block px-2 w-full rounded-xl border-0 py-1.5  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6 pr-10"
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center pr-2 cursor-pointer text-gray-600"
                  >
                    {showPassword ? (
                      <EyeOffIcon className="h-5 w-5" />
                    ) : (
                      <EyeIcon className="h-5 w-5" />
                    )}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-center">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="btn-color-talangmas h-11 flex w-full justify-center items-center rounded-xl hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                >
                  {isLoading ? <Spinner classAddition={"w-5"} /> : "Sign In"}
                </button>
              </div>
            </form>

                    <p className="text-sm w-full text-center mt-4">Don't have an account? <button type="button" onClick={() => navigate("/register")}><span className="text-color-talangmas">Sign Up</span></button></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
